<template>
	<!-- <el-cascader
		ref="cascader"
		class="cascader-bid"
		v-model="model"
		:placeholder="placeholder"
		:options="options"
		:props="props"
		clearable
		filterable
		@change="changeHandler"
	></el-cascader> -->

	<el-select 
	multiple
	ref="cascader"
	class="cascader-bid"
	v-model="model"
	:placeholder="placeholder"
	clearable
	filterable
	@change="changeHandler"
	>
		<el-option
		v-for="item in options"
		:key="item.id"
		:label="`${item.name}`"
		:value="item.id">
		</el-option>
	</el-select>
</template>

<script>
import MODEL from '@/mixins/model'
import TWO_WAY from '@/mixins/2way'

export default {
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		zbprocode: {
			type: String,
			default: ''
		},
		isXt: {
            type: String,
			default: ''
        },
	},
	mixins: [MODEL, TWO_WAY],
	data() {
		return {
			options: [],
			map: {}
		};
	},
	computed: {
		model: {
			get() {
				if(getType(this.value) === 'string') {
					if(!this.value) {
						return [];
					};
					return this.value.split(',').reduce((arr, item) => {
						item && arr.push(item);
						return arr;
					}, []);
				};
				return this.value;
			},
			set(val) {
				if(getType(val) === 'array') {
					var value = '';
					if(val.length) {
						value = val.join(',') + ',';
					};
					this.$emit('input', value);
				} else {
					this.$emit('input', val);
				};
			}
		}
	},
	watch: {
		zbprocode() {
			this.queryData();
		}
	},
	methods: {
		queryData(node, resolve) {	
			if(!this.zbprocode) return;
			if(this.isXt==1) {
				this.$post(`${this.getGetters('ageUrl')}/revision/tree/getprobd.json`, {
					zbprocode: this.zbprocode
				}, data => {
					var arr;
					try{
						arr = JSON.parse(data.treeObject);
					} catch(e) {
						arr = data.treeObject;
					};
					this.options = arr;
					this.map = arr.reduce((obj, item) => {
						obj[item.id] = item;
						return obj;						
					}, {});
				});
			}
			if(this.isXt==0||this.isXt==undefined) {
				this.$post(`${this.getGetters('ageUrl')}/revision/tree/getprobd4.json`, {
					zbprocode: this.zbprocode,
				}, data => {
					var arr;
					try{
						arr = JSON.parse(data.treeObject);
					} catch(e) {
						arr = data.treeObject;
					};
					this.options = arr;
					this.map = arr.reduce((obj, item) => {
						obj[item.id] = item;
						return obj;					
					}, {});
				});
			}
		},
		changeHandler(e) {
			var selNode = e.reduce((arr, item) => {
				arr.push(this.map[item]);
				return arr;
			}, []);
				var selNodeMap = selNode.map(item => item.name);
				var name = '';
				if(selNodeMap.length) {
					name = (selNode.map(item => item.name).join(',') + ',');
				};
				this.twoWayHandler({
					name
				});
				this.$emit('select', selNode);
		}
	},
	created() {
		this.queryData();
	}
}
</script>

<style>
	.cascader-bid{width:100%;}
</style>


              